// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  width: -webkit-fill-available;
  max-width: inherit;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4rem;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
}

.logo-icon {
  width: 2rem;
  height: 2rem;
  background: #2563eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.875rem;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: bold;
  color: #2563eb;
}

.desktop-nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-link {
  color: #374151;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #2563eb;
}

.primary-button {
  background:#2563eb;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
}

.container .primary-button:hover {
  background: white;
}

.secondary-button {
  background: transparent;
  color: #2563eb;
  padding: 0.75rem 1.5rem;
  border: 2px solid #2563eb;
  border-radius: 0.375rem;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.secondary-button:hover {
  background: #2563eb;
  color: white;
}

.mobile-menu-button {
  display: none;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
}

.hamburger {
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25rem;
}

.hamburger span {
  display: block;
  width: 100%;
  height: 2px;
  background: #374151;
}

.mobile-nav {
  display: none;
  padding: 1rem 0;
  border-top: 1px solid #e5e7eb;
}

.mobile-nav-link {
  display: block;
  padding: 0.75rem 1rem;
  color: #374151;
  text-decoration: none;
}

.mobile-nav-link:hover {
  color: #2563eb;
}

.mobile-button {
  display: block;
  width: 100%;
  text-align: center;
  background: #2563eb;
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  font-weight: 600;
  margin: 0.5rem 1rem;
  text-decoration: none;
}

@media (max-width: 768px) {
  .desktop-nav {
    display: none;
  }

  .mobile-menu-button {
    display: block;
  }

  .mobile-nav {
    display: block;
  }
}

/* Enhanced styles for better UX */
.chevron {
  transition: transform 0.2s ease;
}

.chevron.rotated {
  transform: rotate(180deg);
}

.mobile-menu-button.open .hamburger span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.mobile-menu-button.open .hamburger span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-button.open .hamburger span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}

.user-profile-button {
  transition: all 0.2s ease;
}

.user-profile-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.user-profile-button:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.user-menu-item:focus {
  outline: 2px solid #3b82f6;
  outline-offset: -2px;
}

/* Rest of your existing CSS styles... */`, "",{"version":3,"sources":["webpack://./src/components/GuestPage/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,kCAAkC;AAClC;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,wCAAwC","sourcesContent":[".header {\n  background: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n}\n\n.nav {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n  width: -webkit-fill-available;\n  max-width: inherit;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 4rem;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n}\n\n.logo-icon {\n  width: 2rem;\n  height: 2rem;\n  background: #2563eb;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 0.875rem;\n}\n\n.logo-text {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: #2563eb;\n}\n\n.desktop-nav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.nav-link {\n  color: #374151;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.nav-link:hover {\n  color: #2563eb;\n}\n\n.primary-button {\n  background:#2563eb;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.375rem;\n  text-decoration: none;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.container .primary-button:hover {\n  background: white;\n}\n\n.secondary-button {\n  background: transparent;\n  color: #2563eb;\n  padding: 0.75rem 1.5rem;\n  border: 2px solid #2563eb;\n  border-radius: 0.375rem;\n  text-decoration: none;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.secondary-button:hover {\n  background: #2563eb;\n  color: white;\n}\n\n.mobile-menu-button {\n  display: none;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n}\n\n.hamburger {\n  width: 1.5rem;\n  height: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.25rem;\n}\n\n.hamburger span {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #374151;\n}\n\n.mobile-nav {\n  display: none;\n  padding: 1rem 0;\n  border-top: 1px solid #e5e7eb;\n}\n\n.mobile-nav-link {\n  display: block;\n  padding: 0.75rem 1rem;\n  color: #374151;\n  text-decoration: none;\n}\n\n.mobile-nav-link:hover {\n  color: #2563eb;\n}\n\n.mobile-button {\n  display: block;\n  width: 100%;\n  text-align: center;\n  background: #2563eb;\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n  font-weight: 600;\n  margin: 0.5rem 1rem;\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .desktop-nav {\n    display: none;\n  }\n\n  .mobile-menu-button {\n    display: block;\n  }\n\n  .mobile-nav {\n    display: block;\n  }\n}\n\n/* Enhanced styles for better UX */\n.chevron {\n  transition: transform 0.2s ease;\n}\n\n.chevron.rotated {\n  transform: rotate(180deg);\n}\n\n.mobile-menu-button.open .hamburger span:nth-child(1) {\n  transform: rotate(45deg) translate(5px, 5px);\n}\n\n.mobile-menu-button.open .hamburger span:nth-child(2) {\n  opacity: 0;\n}\n\n.mobile-menu-button.open .hamburger span:nth-child(3) {\n  transform: rotate(-45deg) translate(7px, -6px);\n}\n\n.user-profile-button {\n  transition: all 0.2s ease;\n}\n\n.user-profile-button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.user-profile-button:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n.user-menu-item:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: -2px;\n}\n\n/* Rest of your existing CSS styles... */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
